export const getSortedTags = tagsArray =>
  tagsArray.sort((tag1, tag2) => tag1.name.localeCompare(tag2.name));
